// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1X7ni","header":"ClearentDisclaimer_header__3BLpZ","inner":"ClearentDisclaimer_inner__2qMvq"};